/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Dark_Gull_WadeInputs */

const en_cool_dark_gull_wade = /** @type {(inputs: Cool_Dark_Gull_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization default`)
};

const de_cool_dark_gull_wade = /** @type {(inputs: Cool_Dark_Gull_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisationsstandard`)
};

/**
* | output |
* | --- |
* | "Organization default" |
*
* @param {Cool_Dark_Gull_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_dark_gull_wade = /** @type {((inputs?: Cool_Dark_Gull_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Dark_Gull_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_dark_gull_wade(inputs)
	return de_cool_dark_gull_wade(inputs)
});